import React from 'react';
import ReactMoment from 'react-moment';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/de';
import 'moment/locale/es';
let lang = (localStorage.getItem('lang')) ? localStorage.getItem('lang') : 'en';
moment.locale(lang.toLowerCase());

/**
 * Retourne la date au format prédéfini dans la session (en fonction de la langue)
 * @param {string} props.format 
 * @param {object} props.children
 */
const MomentCustomer = (props) => {
  let format = localStorage.getItem('formatDate');
  let lang = localStorage.getItem('lang');
  if(lang)lang = lang.toLowerCase();

  if(props) {
    if(props.format !== undefined) {
      format = props.format;
    }
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <ReactMoment locale={lang} format={format}>{props.children}</ReactMoment>
  )
}

export default MomentCustomer;